import React, { createContext, useContext } from "react";
import { useMsal } from "@azure/msal-react";

const RoleContext = createContext();

export const RoleProvider = ({ children }) => {
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const roles = activeAccount?.idTokenClaims.roles || [];
  const isAdmin = roles.includes("cvp.write");

  return (
    <RoleContext.Provider value={{ isAdmin }}>{children}</RoleContext.Provider>
  );
};

export const useRoleContext = () => {
  const context = useContext(RoleContext);
  if (!context)
    throw new Error("useRoleContext must be used within RoleContext");
  return context;
};
